module.exports = __webpack_public_path__ + "04f49955ff9940ba305beff059e092f7.svg";